import config from "../../config";
import React from "react";
import styled from "styled-components";
import theme from "../../styles/theme";
import {
  ConstructorStandingsItem,
  ConstructorStandingsItemSkeleton,
} from "./ConstructorStandingsItem";
import _ from "lodash";
import { getDivisionColor, getDivisionTextColor, getDivisionPriority } from "../../utils/helpers/divisionUtils";

const StandingsContainer = styled.div`
  padding: 4px 0px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const DivisionBadge = styled.span`
  background-color: ${(props) => props.$color || "transparent"};
  color: ${(props) => props.$textColor || theme.colors.grey};
  padding: ${(props) => (props.$color ? "4px 8px" : "4px 0")};
  font-size: 14px;
  font-weight: bold;
  border-radius: 4px;
  text-transform: uppercase;
  font-family: "Roboto Condensed", sans-serif;
  margin-top: 16px;
  margin-bottom: 8px;
  align-self: flex-start;
`;

const ConstructorStandings = ({ teams, selectedDivision, divisionColors }) => {
  if (!teams) {
    return (
      <StandingsContainer>
        {_.times(10, (i) => <ConstructorStandingsItemSkeleton key={i} />)}
      </StandingsContainer>
    );
  }

  const isMap = !Array.isArray(teams);
  const divisions = isMap ? Object.keys(teams).sort((a, b) => getDivisionPriority(divisionColors, a) - getDivisionPriority(divisionColors, b)) : [config.defaultDivision];
  const isMultiDivision = isMap && divisions.length > 1 && !selectedDivision;
  const divisionsToRender = selectedDivision && isMap && teams[selectedDivision] ? [selectedDivision] : divisions;

  return (
    <StandingsContainer style={{ gap: isMultiDivision ? "24px" : "8px" }}>
      {divisionsToRender.map((division) => {
        const list = isMap ? (teams[division] || []) : teams;
        const divisionColor = getDivisionColor(divisionColors, division);
        return (
          <div key={division} style={{ display: "flex", flexDirection: "column" }}>
            {isMultiDivision && (
              <DivisionBadge
                $color={divisionColor}
                $textColor={divisionColor ? getDivisionTextColor(divisionColor) : undefined}
              >
                {division}
              </DivisionBadge>
            )}
            <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
              {list.map((item, i) => (
                <ConstructorStandingsItem key={i} {...item} />
              ))}
            </div>
          </div>
        );
      })}
    </StandingsContainer>
  );
};

export default ConstructorStandings;
